export default {
    getTheme: function () {
        return localStorage.getItem("theme");
    },

    setTheme: function (sTheme: string) {
        if (sTheme) {
            sap.ui.getCore().applyTheme(sTheme);
            localStorage.setItem("theme", sTheme)
        }
    },

    initTheme: function () {
        const sTheme = this.getTheme();
        if (sTheme) {
            this.setTheme(sTheme)
        }
    }
};